import Axios from "axios";
import { config } from "./config";

const axiosConfig = {
    baseURL: config.API_BASE_URL,
} as const;

export const axiosClient = Axios.create(axiosConfig);
